import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import usePageMeta from '../hooks/usePageMeta';
import { productMeta, SITE_NAME, SITE_URL } from '../seo/site';
import StructuredData from '../components/StructuredData';
import ProductSection from '../components/ProductSection';
import BundleStrip from '../components/BundleStrip';
import Footer from '../components/Footer';
import FloatingParticles from '../components/FloatingParticles';
import Navigation from '../components/Navigation';

const ProductPage = ({ content }) => {
  const { productId } = useParams();
  const product = content.products.find((item) => item.id === productId);
  const otherProducts = content.products.filter((item) => item.id !== productId);

  usePageMeta(
    product
      ? productMeta(product)
      : {
          title: `Page Not Found | ${SITE_NAME}`,
          description: 'The requested Freedman Labs app page could not be found.',
          canonical: `${SITE_URL}/404`,
          robots: 'noindex, nofollow',
        }
  );

  if (!product) {
    return <Navigate to="/404" replace />;
  }

  return (
    <>
      <StructuredData content={content} product={product} />
      <div className="home-page-wrapper">
        <ProductSection product={product} animateOnEnter={false} />
        <BundleStrip
          bundle={content.bundle}
          products={content.products}
          otherProducts={otherProducts}
          sectionId={null}
          variant="page"
        />
        <Footer content={content.site} products={content.products} />
      </div>
      <FloatingParticles />
      <Navigation content={content.navigation} products={content.products} />
    </>
  );
};

export default ProductPage;
